import React, { useEffect, useState, useRef } from "react";
import { UmbracoStep } from "components/Umbraco/UmbracoContext";
import utils from "utils";
import {
  CheckValidInputs,
  StepBody,
  Line,
  LabelBig,
  PhoneField,
  CheckBox,
  ToggleGroup,
  TextField,
  StepFooter,
  useInput,
  IdNumberField,
  MainCond,
  DateField,
  Datepicker,
  EmailField,
  ToggleGender,
  AutoComplete,
  RowCenter,
  Row,
  InnerSmall,
} from "meitav-uikit";
import { Parser } from "html-to-react";
import { isMobile } from "react-device-detect";
import { popupWin } from "components/PopUps";
import {
  setDataLayer,
  postData,
  getAge,
  generateB2SeeToken,
} from "../../../../../utils/Functions";
import "./Step21.scss";
import Footer from "components/Footer";

const { UmbracoUtills, rest } = utils;
const getCID = function () {
  let cid = null;
  const { cookie } = document;
  if (cookie !== undefined && cookie.length > 0) {
    const cookies = cookie.split("_ga")[1];
    if (cookies !== undefined && cookies.length > 0)
      cid = cookies.split("=")[1].split(";")[0];
    if (cid) {
      const cidString = cid.split(".");
      if (cidString.length > 3) {
        cid = `${cidString[2]}.${cidString[3]}`;
      }
    }
  }
  return cid;
};

const getGCLID = function () {
  let gclid = null;
  const { cookie } = document;
  if (cookie !== undefined && cookie.length > 0) {
    const cookies = cookie.split("_gcl_aw")[1];
    if (cookies !== undefined && cookies.length > 0)
      gclid = cookies.split("=")[1].split(";")[0];
    if (gclid) {
      const gclidstring = gclid.split(".");
      if (gclidstring.length > 2) {
        gclid = gclidstring[2];
      }
    }
  }
  return gclid;
};

function getDCLID() {
  let dclid = null;
  const { cookie } = document;
  if (cookie !== undefined && cookie.length > 0) {
    const cookies = cookie.split("_gcl_dc")[1];
    if (cookies !== undefined && cookies.length > 0)
      dclid = cookies.split("=")[1].split(";")[0];
    if (dclid) {
      const dclidString = dclid.split(".");
      if (dclidString.length > 2) {
        dclid = dclidString[2];
      }
    }
  }
  return dclid;
}

function getFBCLID() {
  let dclid = null;
  const { cookie } = document;
  if (cookie !== undefined && cookie.length > 0) {
    const cookies = cookie.split("_fbc")[1];
    if (cookies !== undefined && cookies.length > 0)
      dclid = cookies.split("=")[1].split(";")[0];
    if (dclid) {
      const dclidString = dclid.split(".");
      if (dclidString.length > 2) {
        dclid = dclidString[2];
      }
    }
  }
  return dclid;
}
export default function Step21({
  resource,
  model,
  setStep,
  step,
  resourceError,
  disable,
  nextText,
}) {
  const resourceStep = UmbracoStep(resource, `FirstSub2Step`);
  const resourceFirstSub1Step = UmbracoStep(resource, `FirstSub1Step`);
  const p = new Parser();

  const myCond = {
    minAge: {
      msg: UmbracoUtills.getValueByKey(resourceError, "minAge"),
      cond: (value) => getAge(value) < 18,
    },
    checkBox: {
      msg: UmbracoUtills.getValueByKey(resourceError, "errorEmptyField"),
      cond: (value) => !value,
    },
  };

  const [maritalStatusList, setMaritalStatusList] = useState([]);
  const phone = useInput(
    UmbracoUtills.getValueByKey(resourceFirstSub1Step, "phoneNumber"),
    model.mainUser.phone,
    [MainCond.empty, MainCond.phone]
  );
  const firstName = useInput(
    UmbracoUtills.getValueByKey(resourceFirstSub1Step, "firstName"),
    model.mainUser.firstName,
    [MainCond.empty, MainCond.hebrew, MainCond.minLength]
  );
  const lastName = useInput(
    UmbracoUtills.getValueByKey(resourceFirstSub1Step, "lastName"),
    model.mainUser.lastName,
    [MainCond.empty, MainCond.hebrew, MainCond.minLength]
  );
  const iDNumber = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "idLabel"),
    model.mainUser.iDNumber,
    [MainCond.empty, MainCond.identity]
  );
  const birthDate = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "birthDate"),
    model.mainUser?.birthDate,
    [MainCond.empty, MainCond.date, myCond.minAge]
  );
  const maritalStatus = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "maritalStatus"),
    model.mainUser?.maritalStatus,
    [MainCond.empty]
  );
  const gender = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "gender"),
    model.mainUser?.gender,
    [MainCond.empty]
  );
  const email = useInput(
    UmbracoUtills.getValueByKey(resourceFirstSub1Step, "email"),
    model.mainUser?.email,
    [MainCond.empty, MainCond.email]
  );
  const marketingAgreement = useInput(
    p.parse(UmbracoUtills.getValueByKey(resourceStep, "mArketingAgreement")),
    model.mainUser?.marketingAgreement
  );
  const isAllowSMSandEmail = useInput(
    p.parse(UmbracoUtills.getValueByKey(resourceStep, "isAllowSMSandEmail")),
    model.mainUser?.isAllowSMSandEmail,
    [MainCond.must]
  );
  const commonBankAccount = useInput(
    p.parse(UmbracoUtills.getValueByKey(resourceStep, "commonBankAccount")),
    model.mainUser?.commonBankAccount,
    [MainCond.empty]
  );
  const asInvestPartner = useInput(
    p.parse(UmbracoUtills.getValueByKey(resourceStep, "asInvestPartner")),
    model.mainUser?.asInvestPartner
  );
  const option = [
    { text: "כן", value: true },
    { text: "לא", value: false },
  ];
  const [disabledPhone, setDisabledPhone] = useState(false);
  const [marriedNoCommonBankAccount, setMarriedNoCommonBankAccount] =
    useState(false);
  const [popupObj, setPopupObj] = useState("");
  const [flagFirstPage, setFlagFirstPage] = useState(true);

  useEffect(() => {
    setMarriedNoCommonBankAccount(false);
    if (
      commonBankAccount.value === false &&
      ((maritalStatus.value.value != undefined &&
        (maritalStatus.value.value == 2 || maritalStatus.value.value == 5)) ||
        maritalStatus.value == 2 ||
        maritalStatus.value == 5)
    )
      setMarriedNoCommonBankAccount(true);
  }, [commonBankAccount.value, maritalStatus.value]);

  useEffect(() => {
    //fetchData();
    getMaritalStatus();
    getProcessID();

    let obj = {};
    obj.type = "message";
    obj.title = p.parse(
      UmbracoUtills.getValueByKey(resourceStep, "popUpAsInvestPartnerTitle")
    );
    obj.specialText = p.parse(
      UmbracoUtills.getValueByKey(resourceStep, "popUpAsInvestPartnerSubTitle")
    );
    setPopupObj(obj);
    setFlagFirstPage(false);

    if (
      !disable &&
      !model?.isExistingProcess &&
      model.mainUser?.asInvestPartner == false &&
      model.mainUser?.commonBankAccount == true &&
      (maritalStatus.value == 2 || maritalStatus.value == 5) &&
      !model.mainUser?.commonBankAccountFlag &&
      flagFirstPage
    ) {
      popupWin(obj);
    }
  }, []);
  useEffect(() => {
    if (commonBankAccount.value) asInvestPartner.setConds([MainCond.empty]);
    else asInvestPartner.setConds([]);

    if (
      asInvestPartner.value === false &&
      commonBankAccount.value == true &&
      ((maritalStatus.value.value != undefined &&
        (maritalStatus.value.value == 2 || maritalStatus.value.value == 5)) ||
        maritalStatus.value == 2 ||
        maritalStatus.value == 5) &&
      !flagFirstPage &&
      !disable
    )
      popupWin(popupObj);
  }, [asInvestPartner.value, commonBankAccount.value]);

  const getMaritalStatus = async () => {
    const t = await rest.get(`/api/manager/GetMaritalStatus`);
    const options = t.data.map(function (row) {
      return { value: row.MaritalStatusId, text: row.Description };
    });
    setMaritalStatusList(options);
    if (model.mainUser?.maritalStatus) {
      if (!isMobile)
        maritalStatus.setValue(
          options.find((x) => x.value === model.mainUser.maritalStatus).value
        );
      else
        maritalStatus.setValue(
          options.find((x) => x.value === model.mainUser.maritalStatus)
        );
    }
  };

  //const fetchData = async () => {
  //const result = await rest.get("/api/Manager/IsTazDisabled");
  //if (result?.data == "True") setDisabledPhone(true);
  //}

  const getProcessID = async () => {
    const t = await rest.get(`/api/manager/GetProcessId`);

    if (t?.data != 0) window.dataLayer.push({ userID: t.data });
  };

  const handleNext = async () => {
    if (disable) {
      setStep(22);
      return;
    }
    if (
      !CheckValidInputs([
        firstName,
        lastName,
        iDNumber,
        phone,
        email,
        birthDate,
        gender,
        maritalStatus,
        asInvestPartner,
        isAllowSMSandEmail,
        commonBankAccount,
      ])
    ) {
      return;
    }
    setDataLayer(
      "PM - private details",
      "/JoinPersonalDetails",
      "פרטים אישיים",
      "המשך מוצלח של שלב פרטים אישיים נוספים"
    );
    let tmpModel = model;

    let VisitorKey = "";
    try {
      VisitorKey = window.ewt.getVisitorKey();
    } catch (err) {
      VisitorKey = "";
    }
    if (tmpModel.ga_Info == null) tmpModel.ga_Info = {};
    tmpModel.ga_Info.cid = getCID();
    tmpModel.ga_Info.gclid = getGCLID();
    tmpModel.ga_Info.dclid = getDCLID();
    tmpModel.ga_Info.fbclid = getFBCLID();
    tmpModel.ga_Info.visitorKey = VisitorKey;

    tmpModel.mainUser.commonBankAccountFlag = true;
    tmpModel.mainUser.iDNumber = iDNumber.value;
    tmpModel.mainUser.maritalStatus =
      maritalStatus.value.value != undefined
        ? maritalStatus.value.value
        : maritalStatus.value;
    tmpModel.mainUser.gender = gender.value;
    tmpModel.mainUser.birthDate = birthDate.value;
    tmpModel.mainUser.email = email.value;
    tmpModel.mainUser.phone = phone.value;
    tmpModel.mainUser.firstName = firstName.value;
    tmpModel.mainUser.lastName = lastName.value;
    tmpModel.mainUser.marketingAgreement = marketingAgreement.value;
    tmpModel.mainUser.isAllowSMSandEmail = isAllowSMSandEmail.value;
    tmpModel.mainUser.commonBankAccount = commonBankAccount.value;
    tmpModel.mainUser.asInvestPartner = asInvestPartner.value;

    tmpModel.currentStepID = 21;
    tmpModel.stepID = 22;
    postData(tmpModel, setStep);
    generateB2SeeToken(iDNumber.value, VisitorKey);
  };

  return (
    <>
      <StepBody className="Step21">
        <RowCenter>
          <Line className="line">
            <TextField {...firstName} id="firstName" disable={disable} />
            <TextField {...lastName} id="lastName" disable={disable} />
          </Line>
          <Line className="line">
            <IdNumberField id="iDNumber" {...iDNumber} disable={true} />
            <PhoneField {...phone} id="phone" disable={true} />
          </Line>
          <Line className="line">
            <EmailField id="email" {...email} disable={disable} />
            <Datepicker
              id="birthDate"
              {...birthDate}
              disable={disable}
              onBlur={(e) =>
                setDataLayer(
                  "PM - private details",
                  "/JoinPersonalDetails",
                  "פרטים אישיים",
                  `תאריך לידה - ${e}`
                )
              }
            />
          </Line>
        </RowCenter>

        <Row className="part2">
          <ToggleGender
            id="gender"
            disable={disable}
            {...gender}
            direction={!isMobile ? "horizontal" : "vertical"}
            onBlur={(e) =>
              setDataLayer(
                "PM - private details",
                "/JoinPersonalDetails",
                "פרטים אישיים",
                `מגדר - ${e}`
              )
            }
          />
          {isMobile && (
            <AutoComplete
              fre
              id="maritalStatus"
              disable={disable}
              {...maritalStatus}
              options={maritalStatusList}
              optionText="text"
              optionValue="value"
              onBlur={(e) =>
                setDataLayer(
                  "PM - private details",
                  "/JoinPersonalDetails",
                  "פרטים אישיים",
                  `מצב משפחתי - ${e}`
                )
              }
            />
          )}
          {!isMobile && (
            <ToggleGroup
              id="maritalStatus"
              type={`${isMobile ? "box" : ""}`}
              disable={disable}
              {...maritalStatus}
              options={maritalStatusList}
              onBlur={(e) =>
                setDataLayer(
                  "PM - private details",
                  "/JoinPersonalDetails",
                  "פרטים אישיים",
                  `מצב משפחתי - ${e}`
                )
              }
            />
          )}{" "}
          {marriedNoCommonBankAccount ? (
            <RowCenter>
              <LabelBig
                text={p.parse(
                  UmbracoUtills.getValueByKey(
                    resourceStep,
                    "marriedNoCommonBankAccountDisclaimer"
                  )
                )}
              ></LabelBig>
            </RowCenter>
          ) : (
            ""
          )}
          <Line className="line">
            <ToggleGroup
              id="commonBankAccount"
              disable={disable}
              {...commonBankAccount}
              className={`${!isMobile ? "" : "toggleMobile"} `}
              options={option}
              direction={!isMobile ? "horizontal" : "vertical"}
              onBlur={(e) =>
                setDataLayer(
                  "PM - private details",
                  "/JoinPersonalDetails",
                  "פרטים אישיים",
                  `שותפים בחשבון הבנק - ${e}`
                )
              }
            />

            {commonBankAccount.value == true && (
              <ToggleGroup
                id="asInvestPartner"
                className={`asInvestPartner ${
                  !isMobile ? "" : "toggleMobile"
                } `}
                disable={disable}
                {...asInvestPartner}
                options={option}
                direction={!isMobile ? "horizontal" : "vertical"}
              />
            )}
          </Line>
          <CheckBox
            {...isAllowSMSandEmail}
            id="isAllowSMSandEmail"
            disable={disable}
            tooltipText={p.parse(
              UmbracoUtills.getValueByKey(
                resourceStep,
                "isAllowSMSandEmailTooltip"
              )
            )}
          />
          <CheckBox
            {...marketingAgreement}
            id="marketingAgreement"
            disable={disable}
            tooltipText={p.parse(
              UmbracoUtills.getValueByKey(
                resourceStep,
                "marketingAgreementTooltip"
              )
            )}
          />
        </Row>
      </StepBody>
      <StepFooter
        nextText={nextText}
        handleNext={handleNext}
        isPrevHiden={true}
      />
      <Footer
        text={p.parse(UmbracoUtills.getValueByKey(resourceStep, "mainText"))}
      ></Footer>
    </>
  );
}
